import type { IntlShape } from "react-intl";

// Seed identities from Genesis V0049. These aliases affect presentation only, never authorization.
export const VERIFIED_GROUP_ID = "82b5b8ad-cfdc-4c6c-ac75-6560851d2ac1";
export const REGISTERED_GROUP_ID = "42c4cbe4-879e-4ac6-979e-3ac8635b8577";

type GroupLabel = { id: string; name: string; orgUnitId?: string | null; isSystem?: boolean };
export function groupLabel(intl: IntlShape, group: GroupLabel): string {
  if (group.id === VERIFIED_GROUP_ID) return intl.formatMessage({ id: "admin.groups.verified" });
  if (group.id === REGISTERED_GROUP_ID) return intl.formatMessage({ id: "admin.groups.registered" });
  if (isAdministratorGroup(group)) return intl.formatMessage({ id: "admin.role.standard-administrators.name" });
  return group.name;
}
export function isAdministratorGroup(group: GroupLabel): boolean {
  return group.isSystem === true && !group.orgUnitId
    && group.id !== VERIFIED_GROUP_ID && group.id !== REGISTERED_GROUP_ID;
}
export function isSystemGroup(group: GroupLabel): boolean {
  return group.id === VERIFIED_GROUP_ID || group.id === REGISTERED_GROUP_ID || !!group.orgUnitId || group.isSystem === true;
}
export function groupExplanation(intl: IntlShape, group: GroupLabel): string {
  const id = group.id === VERIFIED_GROUP_ID ? "admin.groups.verifiedHint"
    : group.id === REGISTERED_GROUP_ID ? "admin.groups.registeredHint"
    : isAdministratorGroup(group) ? "admin.groups.administratorsHint" : group.orgUnitId ? "admin.groups.departmentHint" : "admin.groups.manualHint";
  return intl.formatMessage({ id });
}
